import React, { useRef, useEffect, useContext } from "react";
import SearchIcon from "assets/svgs/dropdown-search-icon.svg";
import { ReactComponent as SelectArrow } from "assets/svgs/select-arrow.svg";
import useSearch from "hooks/useSearch";
import useToggle from "hooks/useToggle";
import Input from "components/input";
import { ProductFinderContext } from "@root/context/product-finder";

const Search = ({ search, handleSearchChange, optionProperty }) => (
    <div className="relative w-full px-4 mb-2">
        <Input
            placeholder={`Type your ${optionProperty}`}
            className="input"
            type="text"
            value={search}
            setValue={handleSearchChange}
            autoFocus
        />
        <img src={SearchIcon} className="absolute right-6 top-2.5 w-4 h-4 bg-cover" />
    </div>
);

const DisabledDropdown = ({ selected, className, dropdownNumber }) => (
    <div className={`flex flex-col gap-0 opacity-70 w-60 h-8 ${className} ymm-dropdown-text-disabled`}>
        <div className="flex flex-col md:py-2.5 py-1.5 px-2 bg-white rounded-lg relative">
            <div className="flex items-center">
                {/* <div className="dropdown-number ymm-dropdown flex items-center justify-center w-6 h-6 rounded-full bg-[#4E4D4D] text-white mr-2"> */}
                {/*    {dropdownNumber} */}
                {/* </div> */}
                <button type="button" className="ymm-dropdown-text text-gray-701 text-left md:text-base text-base-xs">
                    {selected}
                </button>
            </div>
            <SelectArrow className="shopping-feed-finder__dropdown-arrow absolute w-2.5 h-1.5 right-4 md:top-[18px] top-4" />
        </div>
    </div>
);

export const Dropdown = ({ selected, options, optionProperty, onSelect, hasSearch, className, disabled, dropdownNumber, hasValue }) => {
    const { isOpen, toggle } = useToggle();
    const { search, resetSearch, filteredOptions, handleSearchChange } = useSearch(options, optionProperty);
    const selectedRef = useRef(null);
    const divRef = useRef(null);
    const dropdownRef = useRef(null);
    const { errorField, setErrorField, errorFieldRefresher } = useContext(ProductFinderContext);

    useEffect(() => {
        if (errorField && errorField === optionProperty) {
            toggle();
        }
    }, [errorField, errorFieldRefresher]);

    useEffect(() => {
        if (isOpen && selectedRef.current) {
            const topPos = selectedRef.current.offsetTop;
            divRef.current.scrollTop = topPos - 140;
        }
    }, [isOpen]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) && isOpen) {
                toggle();
                resetSearch();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen]);

    if (disabled) return <DisabledDropdown selected={selected} className={className} dropdownNumber={dropdownNumber} />;

    const handleSelect = (dropdownName, selectedValue) => {
        onSelect(dropdownName, selectedValue);
        toggle();
        resetSearch();
        setErrorField(null);
    };

    return (
        <div ref={dropdownRef} className={`flex flex-col gap-0 w-60 flex-1 h-8 min-w-0 basis-full ${className}`}>
            <div className={`ymm-dropdown-active ${hasValue && "ymm-dropdown-active--has-value"}`}>
                <button 
                    type="button"
                    className="text-gray-701 text-left px-2 pr-4 md:py-2.5 py-1.5 md:text-base text-base-xs flex items-center justify-between w-full relative overflow-hidden"
                    onClick={toggle}
                >
                    <div className="flex items-center min-w-0 flex-1 pr-2">
                        {/* <div className="dropdown-number-active flex-shrink-0 flex items-center justify-center w-6 h-6 rounded-full bg-[#FFCB03] text-white mr-2"> */}
                        {/*    {dropdownNumber} */}
                        {/* </div> */}
                        <span className="ymm-dropdown-text-active block overflow-hidden text-ellipsis whitespace-nowrap">
                            {selected}
                        </span>
                    </div>
                    <SelectArrow
                        className={`shopping-feed-finder__dropdown-arrow-active flex-shrink-0 w-2.5 h-1.5 ${isOpen && "rotate-180"}`}
                    />
                </button>
                {(isOpen && hasSearch)
                 && (
                     <Search
                         search={search}
                         optionProperty={optionProperty}
                         handleSearchChange={handleSearchChange}
                         className="mb-1"
                     />
                 ) }
                {isOpen && (
                    <div className="md:pb-2.5 pb-1.5">
                        <div 
                            ref={divRef}
                            className="max-h-60 overflow-y-scroll overflow-x-clip bg-white flex flex-col text-left md:text-base text-base-xs gap-0 z-10 pl-0 pr-0"
                        >
                            {filteredOptions.map((option) => {
                                const isSelected = selected === option[optionProperty];
                                return (
                                    <div
                                        key={option[optionProperty]}
                                        className={`flex items-start transition-all duration-300 hover:bg-yellow-600 ${selected === option[optionProperty] && "bg-yellow-600"}`}
                                        ref={isSelected ? selectedRef : null}
                                    >
                                        <button
                                            type="button"
                                            className="ymm-dropdown-item__options w-full text-left focus-visible:bg-yellow-600 focus-visible:outline-0 pl-4 pr-2 py-1"
                                            onClick={() => handleSelect(optionProperty, option[optionProperty])}
                                        >
                                            {option[optionProperty]}
                                        </button>
                                    </div>
                                );
                            })}            
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Dropdown;
